import mainService from "./mainService";
const path = "/userDetails/";

export function sendSingleFieldValueOnBlur(data) {
    return mainService
        .post(path + "create", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function userData() {
    return mainService
        .get(path + "userData")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function check(type) {
    return mainService
        .post(path + "check", { type })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function records() {
    return mainService
        .post(path + "records")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function updateProfileData(data) {
    return mainService
        .post(path + "update", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function updatePassWord(data) {
    return mainService
        .post(path + "changePassword", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function deleteAccount() {
    return mainService
        .delete(path + "deleteAccount/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function saveWriter(data) {
    return mainService
        .post(path + "saveData/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function createExternalWriter(data) {
    return mainService
        .post(path + "createExternalWriter/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function updateExternalWriter(data) {
    return mainService
        .post(path + "updateExternalWriter/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



// WEBPACK FOOTER //
// ./src/services/userDatails.jsx